import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';

import * as productApi from '../../lib/api/product';
import { finishLoading, startLoading } from '../loading';

const [
  LIST_PRODUCTS_PRICE,
  LIST_PRODUCTS_PRICE_SUCCESS,
  LIST_PRODUCTS_PRICE_FAILURE,
] = createRequestActionTypes('product/LIST_PRODUCTS_PRICE');
export const listProductsPrice = createAction(
  LIST_PRODUCTS_PRICE,
  (searchData) => searchData,
);
// 원가산출 "제품 추가" 모달 전용 조회 (2026-10-20 "거래처별 가격 제안" 제거).
// 이전엔 getProductPriceListByVendor(→ /priceList → ProductService.getProductPriceListAuto)로
// 매출처 등급(고객사/파트너/프리미엄파트너/소비자가)에 따라 매입가를 나눠 매출단가를
// 자동 계산해서 보여줬다. 사용자 결정으로 그 제안 표시 자체를 없애고, 매입 단가만
// 보여주도록 getProductPriceList(→ /price → ProductService.getProductPriceList2)로
// 바꿨다. 매출처 등급 분기/나누기 공식은 백엔드에 그대로 남겨둠(필요하면 재사용).
const listProductsPriceSaga = createRequestSaga(
  LIST_PRODUCTS_PRICE,
  productApi.getProductPriceList,
);

// function * listProductsPriceSaga(actions){
//   yield put(startLoading(LIST_PRODUCTS_PRICE));

//   try{
//     const res = yield call(productApi.getProductsForPrice, actions.payload);

//     if(res.data.list){

//       _.map(res.data.list, product =>{
//         let prices = JSON.parse(product.priceJson);
//         product.priceUuid = prices[0]['priceUuid'];
//         // product.priceVal = prices[0]['priceVal'];
//         // product.priceTyp = prices[0]['priceTyp'];

//       })
//     }

//     yield put({
//       type: LIST_PRODUCTS_PRICE_SUCCESS,
//       payload: {
//        list:res.data.list,
//       },
//     });

//   }catch(e){
//     yield put({
//       type: LIST_PRODUCTS_PRICE_FAILURE,
//       payload: e,
//       error: true,
//     });
//   }

//   yield put(finishLoading(LIST_PRODUCTS_PRICE));
// }

const UNLOAD_PRODUCTS_PRICE = 'product/UNLOAD_PRODUCTS_PRICE';
export const unloadProductsPrice = createAction(UNLOAD_PRODUCTS_PRICE);

export function* productsPriceSaga() {
  yield takeLatest(LIST_PRODUCTS_PRICE, listProductsPriceSaga);
}

const initialState = {
  products: null,
  error: null,
};

const productsPrice = handleActions(
  {
    [LIST_PRODUCTS_PRICE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      products:
        data.list &&
        data.list.map((product) => ({
          id: product.priceUuid,
          productUuid: product.productUuid,
          productNm: product.productNm,
          modelNm: product.modelNm,
          partnerUuid: product.partnerUuid,
          partnerNm: product.partnerNm,
          category: product.category,
          priceUuid: product.priceUuid,
          pricePartnerUuid: product.pricePartnerUuid,
          pricePartnerNm: product.pricePartnerNm,
          priceTyp: product.priceTyp,
          priceVal: product.priceVal,
          salesVal: product.salesVal,
          price: product.price,
          productDesc: product.productDesc,
          productUnit: product?.productUnit,
        })),
      error: null,
    }),
    [LIST_PRODUCTS_PRICE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PRODUCTS_PRICE]: () => initialState,
  },
  initialState,
);

export default productsPrice;
